export const GET_VIP_OFFERS = 'GET_VIP_OFFERS';
export const GET_VIP_OFFERS_SUCCESS = 'GET_VIP_OFFERS_SUCCESS';
export const GET_VIP_OFFERS_ERROR = 'GET_VIP_OFFERS_ERROR';
export const CONFIRM_REWARD_SELECTION = 'CONFIRM_REWARD_SELECTION';
export const CONFIRM_REWARD_SELECTION_SUCCESS = 'CONFIRM_REWARD_SELECTION_SUCCESS';
export const CONFIRM_REWARD_SELECTION_ERROR = 'CONFIRM_REWARD_SELECTION_ERROR';
